import React from 'react';
import { UL, LI, H6, P } from '../../../AbstractElements';
import { LadiesHandbags, LatestCamera, LatestSonyHeadPhone, Month } from '../../../Constant';
const SellingList = () => {
  return (
    <>
      <UL className='selling-list'>
        <LI>
          <div className='icon'>
            <i className=' m-0 icon-headphone-alt' />
          </div>
          <div>
            <P>{LatestSonyHeadPhone}</P>
            <H6>
              84.6K<span>/ {Month}</span>
            </H6>
          </div>
        </LI>
        <LI>
          <div className='icon'>
            <i className=' m-0 icon-bag' />
          </div>
          <div>
            <P>{LadiesHandbags}</P>
            <H6>
              23.5K<span>/ {Month}</span>
            </H6>
          </div>
        </LI>
        <LI>
          <div className='icon'>
            <i className=' m-0 icon-video-camera' />
          </div>
          <div>
            <P>{LatestCamera}</P>
            <H6>
              84.6K<span>/ {Month}</span>
            </H6>
          </div>
        </LI>
      </UL>
    </>
  );
};

export default SellingList;
